import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentStep: 'activate-start',
    cardSubtile: '',
    viewState: 'Idle',
    error: null,
    vtsFound: false,
    vtsInfo: {},
    contact: {},
    privacy: {},
    activations: [],
    activationResults: null
  },
  getters: {
    getCardSubtitle: state => {
      return state.cardSubtile
    },
    _getFormattedServerError: () => (error) => {
      let errorMessage = `We're sorry, something went wrong while processing your request.`
      if (error.response && error.response.status) {
        switch (error.response.status) {
          case 400:
            errorMessage = `We couldn't gather all the information needed to activate your software. Have you completed all required fields?`
            break
          case 500:
            errorMessage = `We're sorry, the activation service doesn't seem to be available at this time.`
            break
        }
      }
      return errorMessage
    }
  },
  mutations: {
    setSubtitle(state, message) {
      state.cardSubtile = message
    },
    setVtsInfo(state, info) {
      state.vtsInfo = info
    },
    setContact(state, contact) {
      state.contact = contact
    },
    setPrivacy(state, privacy) {
      state.privacy = privacy
    },
    setVtsInfoNumber(state, vtsNumber) {
      state.vtsInfo.vts_number = vtsNumber.trim().toUpperCase()
    },
    setCurrentStep(state, step) {
      state.currentStep = step
    },
    setVtsFound(state, value) {
      state.vtsFound = value
    },
    setViewState(state, viewState) {
      state.viewState = viewState
    },
    setError(state, error) {
      state.error = error
    },
    setActivationResults(state, results) {
      state.activationResults = results
    }
  },
  actions: {
    setSubtitle({ commit }, message) {
      commit('setSubtitle', message)
    },
    storeContactPrivacy({ commit }, contactPrivacyInfo) {
      commit('setContact', contactPrivacyInfo[0])
      commit('setPrivacy', contactPrivacyInfo[1])
    },
    async vtsLookup({ commit, getters }, vtsNumber) {
      try {
        let url = `/.netlify/functions/get-vts-info?vtsNumber=${vtsNumber.trim().toUpperCase()}`
        let response = await axios.get(url)
        commit('setVtsInfo', response.data)
        commit('setVtsFound', true)
        commit('setCurrentStep', 'activate-confirm')
        commit('setViewState', 'Idle')
      } catch (error) {
        if (error.response && error.response.status == 404) {
          commit('setVtsFound', false)
          commit('setCurrentStep', 'activate-confirm')
          commit('setVtsInfoNumber', vtsNumber)
          commit('setViewState', 'Idle')
        }
        else {
          console.error('Error', error)
          commit('setViewState', 'Error')
          let formattedError = getters._getFormattedServerError(error)
          commit('setError', formattedError)
        }
      }
    },
    confirmDetails({ commit }, vtsInfo) {
      commit('setVtsInfo', vtsInfo)
      commit('setCurrentStep', 'activate-request')
    },
    async submitActivations({ commit, state, getters }, connectedPCs) {
      try {
        let url = `/.netlify/functions/create-activations`
        let response = await axios.post(url, {
          org_info: state.vtsInfo,
          user_info: {
            name: state.contact.name,
            email: state.contact.email,
            agrees_contact: state.privacy.agreesContact
          },
          machine_names: connectedPCs
        })
        commit('setActivationResults', response.data)
        commit('setCurrentStep', 'activate-codes')
        commit('setViewState', 'Idle')
      } catch (error) {
        console.log('Error', error)
        commit('setViewState', 'Error')
        let formattedError = getters._getFormattedServerError(error)
        commit('setError', formattedError)
      }
    }
  },
  modules: {
  }
})
